export default "__VITE_ASSET__BIpnSWIz__"